export const ENTITY_DASHBOARD_BASE_PATH = "/executive-dashboard";
export const MOBILE_EXECUTIVE_DASHBOARD_PATH = ENTITY_DASHBOARD_BASE_PATH;
export const PENDING_APPROVALS_PATH = "/rfqs/workspace/pending-approvals";

const normalizeId = (value) => String(value || "").trim();

export const getCurrentUserEntityId = (user = {}) =>
  normalizeId(user?.userEntity?.entityId || user?.entity?.entityId || user?.entityId);

export const getCurrentUserEntityName = (user = {}) =>
  normalizeId(user?.userEntity?.entityName || user?.entity?.entityName || user?.entityName);

export const getDashboardEntityId = (user = {}) => normalizeId(user?.dashboardEntityId);

export const hasPendingApprovalsAccess = (user = {}) => {
  const hasApprovalFlow = (user?.userEntity?.features || []).some(
    (feature) => feature?.featureName === "APPROVAL_FLOW" && feature?.hasFeature === true
  );

  return user?.IAM_role === "Manager" && hasApprovalFlow;
};

export const getDashboardEntitySlug = (entityName = "") => {
  const slug = normalizeId(entityName)
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || "entity";
};

export const getEntityDashboardPath = (entityId, entityName = "") => {
  const normalizedEntityId = normalizeId(entityId);
  const entitySlug = getDashboardEntitySlug(entityName || normalizedEntityId);

  return `${ENTITY_DASHBOARD_BASE_PATH}/${encodeURIComponent(normalizedEntityId)}/${entitySlug}`;
};

export const hasEntityDashboardAccess = (user = {}, routeEntityId = "") => {
  const currentEntityId = getCurrentUserEntityId(user);
  const dashboardEntityId = getDashboardEntityId(user);
  const requestedEntityId = normalizeId(routeEntityId);

  if (!currentEntityId || !dashboardEntityId) return false;
  if (currentEntityId !== dashboardEntityId) return false;
  if (requestedEntityId && requestedEntityId !== dashboardEntityId) return false;

  return true;
};

export const getAuthorizedDashboardEntityId = (user = {}) => {
  const currentEntityId = getCurrentUserEntityId(user);
  const dashboardEntityId = getDashboardEntityId(user);

  return currentEntityId && currentEntityId === dashboardEntityId ? dashboardEntityId : "";
};
